import React from "react";

export default function Pagination({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null; // no pagination needed

  const handlePrev = () => {
    if (page > 0) onPageChange(page - 1);
  };

  const handleNext = () => {
    if (page < totalPages - 1) onPageChange(page + 1);
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <button
        className="btn btn-outline-primary"
        onClick={handlePrev}
        disabled={page === 0}
      >
        &laquo; Prev
      </button>

      <span>
        Page {page + 1} of {totalPages}
      </span>

      <button
        className="btn btn-outline-primary"
        onClick={handleNext}
        disabled={page >= totalPages - 1}
      >
        Next &raquo;
      </button>
    </div>
  );
}
